import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../../app/store'
import fetchAPI from '../../../common/fetchAPI'
import { ApiRecordLogStateClass } from './interfaces/ApiRecordLogStateClass' 
import { start } from 'repl'
const initialState: ApiRecordLogStateClass = {
    isLoading: true,
    status: 'idle',
    apiRecordLogList: [],
    selectedRecord: {},
    isReload : false,
    // currentPage : 1,
    pageSize:10,
    totalItems:0,
    // start:0,
    search:" ",
    RequestBody:"",
    RequestURI:"",
    SystemWebHookSourceName:"",
    ActionDescription:"",
    columnIndex:0,
    direction:"asc",
    recordsFiltered: 0,
    isSort:false,
    isSearch:false,
    pageNo: 1,
    startRec: 0,
    sortOrder: 'asc',
    sortColumn: '1',
    webhookreceiverlogid: ""
    
    
}
interface IThunkApi {
    state: {
        apiRecordLog: ApiRecordLogStateClass;
    },
}
export const getAccountApiRecordLogAsync = createAsyncThunk
    <any, { webhookreceiverlogid?: string }, IThunkApi>
   
    (
        'ApiRecordLog/V2/getAccountApiRecordLog',
        async (arg, thunkApi) => {
            const {pageNo,pageSize, startRec, sortColumn, sortOrder, webhookreceiverlogid, search } = thunkApi.getState().apiRecordLog;
            
            const idToUse = arg.webhookreceiverlogid ?? '000';
            const response = await fetchAPI(`api/V2/Logs/ApiRecordLogDatatable/${pageNo}/${pageSize}/${startRec}/${sortColumn}/${sortOrder}/${idToUse}/${search}`, `Get`, '', true);
            const json = await response.json(); 
            return json;          

        }
    )
    
    export const getApiRecordLogAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'ApiRecordLog/V2/getApiRecordLog',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/Logs/ApiRecord/'+arg , 'Get', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;           
        }
    )

export const apiRecordLogSlice = createSlice({
    name: 'apiRecordLog',
    initialState,
    reducers: {
        updatePagination: (state, action: PayloadAction<any>) => {
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
            state.search = action.payload.search;
        },
      updateSearchPagination: (state, action: PayloadAction<any>) => {
            state.isSearch = state.isSearch ? false : true;
            state.search = action.payload;
        },
        updateSorting: (state, action: PayloadAction<any>) => {
            state.sortOrder = action.payload.sortOrder;
            state.sortColumn = action.payload.sortColumn;
            state.startRec = action.payload.startRec;
            state.pageSize = action.payload.pageSize;
            state.pageNo = action.payload.pageNo;
        },

        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        }, 
        setSortConfig: (state, action) => {
            const {columnIndex,direction} = action.payload;
            let ndirection = 'asc';
            if (state.columnIndex === columnIndex && state.direction === 'asc') {
                ndirection = 'desc';
            }
            state.direction = ndirection;
            state.columnIndex = columnIndex;
            state.isSort = true;
         },
         setPageSize: (state, action) => {
            state.pageSize = action.payload;
         },
         setSearchValue: (state, action) => {
            state.search = action.payload;
            state.pageNo = 1;
            state.isSearch = true;
            
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getAccountApiRecordLogAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;
            })
            .addCase(getAccountApiRecordLogAsync.fulfilled, (state, { payload }) => {
                let apiRecordLogList = JSON.parse(payload.Data.data);
                state.status = 'idle';

                if (apiRecordLogList.length > 0) {
                    state.apiRecordLogList = Array.isArray(payload.Data.data) ? payload.Data.data : JSON.parse(payload.Data.data || '[]');
                }                

                state.selectedRecord = {};
                state.pageNo = payload.Data.currentPage;
                state.startRec = payload.Data.start;
                state.totalItems = payload.Data.recordsTotal;
                state.search = payload.Data.search;
                state.isLoading = false;
                state.isSort = false;
                state.isSearch = false;
                
            })
         
            .addCase(getAccountApiRecordLogAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;
                state.isSort = false;
                state.isSearch = false;
                
            })

            .addCase(getApiRecordLogAsync.pending, (state) => {
                state.status = 'loading';
                state.isLoading = true;

            })
            .addCase(getApiRecordLogAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isLoading = false;
                state.RequestBody = JSON.parse(payload.Data.RequestBody);
                state.RequestURI = payload.Data.RequestURI;
                state.ActionDescription = payload.Data.ActionDescription;

            })
            .addCase(getApiRecordLogAsync.rejected, (state) => {
                state.status = 'failed';
                state.isLoading = false;

            })


            
            
    }
})

export const {
    resetSelectedRecordObjectInState,setSortConfig,setPageSize,setSearchValue,updatePagination, updateSearchPagination,updateSorting
} = apiRecordLogSlice.actions
export const ApiRecordLogState = (state: RootState) => state.apiRecordLog
export default apiRecordLogSlice.reducer
